module.exports = __webpack_public_path__ + "assets/5cd9b8dfc235c26f696dac3190f4103a.mp3";